// AUTO-GENERATED FILE. DO NOT EDIT.

import * as nspd_integration from './modules-copy/nspd-integration/index.js';
import * as spd_plus from './modules-copy/spd-plus/index.js';

export const modules = [
  { 
    id: 'nspd-integration', 
    Panel: nspd_integration.Panel, 
    getTools: nspd_integration.getTools,
    ...nspd_integration 
  },
  { 
    id: 'spd-plus', 
    Panel: spd_plus.Panel, 
    getTools: spd_plus.getTools,
    ...spd_plus 
  },
];
